export const educationData = [
    {
        id: 1,
        institution: 'Veer Narmad South Gujrat University',
        course: 'Bachelor of Computer Application (BCA)',
        startYear: '2018',
        endYear: '2021'
    },
    {
        id: 2,
        institution: 'Veer Narmad South Gujrat University',
        course: 'Master of Computer Application (MCA)',
        startYear: '2022',
        endYear: '2024'
    },
]